$(document).on('ready turbolinks:load', () => {
  const $searchIcon = $('.page-search span.search-icon');
  $searchIcon.off('click').click(() => {
    const url = $searchIcon.siblings('input#filter').data('url');
    const params = [];

    $searchIcon.closest('.page-search').find('input').each((index, input) => {
      if (input.value.length > 0) {
        params.push(`${encodeURIComponent(input.name)}=${encodeURIComponent(input.value)}`);
      }
    });

    Turbolinks.visit(`${url}?${params.join('&')}`);
  });
});
